<template>
  <div>
    <div class="p-2 flex flex-col justify-center cursor-pointer gap-1" @click="downloadQrCode">
      <div ref="qrCodeCanvas" class="mx-auto" />
      <p class="text-2xs text-center text-gray uppercase">Click to Download</p>
    </div>
    <div class="hidden" ref="qrCodeDownloadCanvas" />
  </div>

</template>

<script setup>
  import {generateQRCode} from '~/services/core/qr-code.js';

  const props = defineProps({
    filename: String,
    url: String
  });

  const qrCode = ref(null);
  const qrCodeDownload = ref(null);
  const qrCodeCanvas = ref();
  const qrCodeDownloadCanvas = ref();

  function downloadQrCode() {
    const link = document.createElement('a');
    link.download = `qr_${props.filename}.png`;
    link.href = qrCodeDownload.value?._oDrawing.dataURL;
    link.click();

    useSuccessToast().add({
      id: 'qr-dl-success',
      description: 'QR Code downloaded to your Downloads folder.'
    })
  }

  onMounted(() => {
    qrCodeDownload.value = generateQRCode(qrCodeDownloadCanvas.value, {
      text: props.url,
      size: 500
    });
    qrCode.value = generateQRCode(qrCodeCanvas.value, {
      text: props.url,
      size: 200
    });

  });

</script>
